import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

const routeRecord: RouteRecordRaw = {
  name: 'client.acknowledgment.required',
  path: 'acknowledgment-required',
  component: () => import('src/client/pages/AcknowledgmentRequired.vue'),
  meta: {
    roles: [Roles.Client],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
  },
}

export default routeRecord
